export const NewFlag = () => (
    <span className="navigation__item-flag">Neu</span> // Example placeholder for the new flag component
);